import React from 'react';
import { LockFilled, Moon, Sun } from '@withjoy/joykit/icons';
import { Bullet, Container, Label, Option, VisibilityOption } from './ProductIndicator.styles';
import { ProductVisibilityEnum } from '@apps/admin/routes/Dashboard/common/enums/ProductVisibilityEnum';
import { useTranslation } from '@shared/core';
import { ProductIndicatorProps } from './ProductIndicator.types';
import { usePageSettingsDialogContext } from '@apps/registry/admin/routes/YourRegistry/components/PageSettingsDialog/PageSettingsDialog.provider';

const VisibilityOptionWrapper: React.FC<{ href?: string; onClick: () => void; showVisibilityDialog?: boolean }> = ({ href, onClick, children, showVisibilityDialog }) => {
  const { openPageSettingsDialog } = usePageSettingsDialogContext();
  if (!href) {
    return null;
  }

  const wrapperProps = showVisibilityDialog
    ? ({ as: 'button', onClick: openPageSettingsDialog, children } as const)
    : ({
        href,
        onClick,
        children
      } as const);

  return <VisibilityOption {...wrapperProps} />;
};

const ProductIndicator: React.FC<ProductIndicatorProps> = ({
  isEnabled,
  stringOn,
  stringOff,
  visibility,
  settingsUrl,
  onPageVisibilityClick,
  onToggleClick,
  showVisibilityDialog
}) => {
  const { t2 } = useTranslation('adminDashboardV2');
  const translations = t2('visibility');
  const visibilityLabels = {
    [ProductVisibilityEnum.Hidden]: translations.hidden,
    [ProductVisibilityEnum.Public]: translations.public,
    [ProductVisibilityEnum.Private]: translations.passwordProtected
  };
  const iconVisibility = {
    [ProductVisibilityEnum.Hidden]: <Moon />,
    [ProductVisibilityEnum.Public]: <Sun />,
    [ProductVisibilityEnum.Private]: <LockFilled />
  };

  return (
    <Container>
      <Option onClick={() => onToggleClick?.()}>
        {isEnabled ? stringOn : stringOff}
        <Bullet isEnabled={isEnabled} />
      </Option>
      <VisibilityOptionWrapper href={settingsUrl} onClick={() => onPageVisibilityClick?.()} showVisibilityDialog={showVisibilityDialog}>
        {iconVisibility[visibility]}
        <Label>{visibilityLabels[visibility]}</Label>
      </VisibilityOptionWrapper>
    </Container>
  );
};

export default ProductIndicator;
